import { render, staticRenderFns } from "./AvaliationItemDashboard.vue?vue&type=template&id=fa87bbca"
import script from "./AvaliationItemDashboard.vue?vue&type=script&lang=js"
export * from "./AvaliationItemDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports